module.exports = __webpack_public_path__ + "static/hometheater-b3d2dbe688dc7f7960ce74ff98000533.png";